import { ActivityLogsTablePanel } from "#src/batteries-included-components/Panels/TablePanels/ActivityLogsTablePanel";
import useLocalization from "#src/hooks/useLocalization";
import { StorageKeys } from "@validereinc/common-components";
import { ActivityResourceType, ResourceType } from "@validereinc/domain";
import React from "react";

export const ActivityLogsList = ({
  resourceId,
  resourceType,
  viewConfigStorageKey,
  tableStateStorageKey,
}: Partial<
  Pick<StorageKeys, "viewConfigStorageKey" | "tableStateStorageKey">
> & {
  resourceId?: string;
  resourceType?: { name: ResourceType };
}) => {
  const { localize } = useLocalization();

  const pageTitle = `${
    localize(resourceType?.name ?? "") || "Organization"
  } Change Log`;

  return (
    <ActivityLogsTablePanel
      resourceId={resourceId}
      resourceType={(resourceType?.name as ActivityResourceType) ?? "equipment"}
      title={pageTitle}
      viewConfigStorageKey={viewConfigStorageKey ?? ""}
      tableStateStorageKey={tableStateStorageKey ?? ""}
    />
  );
};
